import {AnalyticsWrapper as BaseAnalyticsWrapper} from '@github-ui/repo-issues-page-layout/AnalyticsWrapper'
import {useMemo} from 'react'

import {useActiveSearchQuery} from '../contexts/QueryContext'
import {useRouteInfo} from '../hooks/use-route-info'

type AnalyticsWrapperProps = {
  /**
   * The category to use for analytics events.
   * e.g Issues Index, Issues Dashboard, etc.
   */
  category: string

  children: React.ReactNode
}
export function AnalyticsWrapper({children, category}: AnalyticsWrapperProps) {
  const activeSearchQuery = useActiveSearchQuery()
  const {viewId} = useRouteInfo()
  const analyticsMetadata = useMemo(
    () => ({viewQuery: activeSearchQuery, viewId: viewId || ''}),
    [activeSearchQuery, viewId],
  )
  return (
    <BaseAnalyticsWrapper category={category} metadata={analyticsMetadata}>
      {children}
    </BaseAnalyticsWrapper>
  )
}
